// component/TrierMerchentModal.js
import React from 'react';
import { Modal, Button, Radio } from 'antd';

const TrierTransactionModal = ({ isOpen, toggle, onApplySort }) => {
  const [sortOrder, setSortOrder] = React.useState('asc');

  return (
    <Modal
      open={isOpen}
      onCancel={toggle}
      onOk={() => {
        onApplySort(sortOrder);
        toggle();
      }}
      title="Trier les transactions"
    >
      <Radio.Group
        onChange={(e) => setSortOrder(e.target.value)}
        value={sortOrder}
      >
        <Radio value="asc">Date croissante</Radio>
        <Radio value="desc">Date décroissante</Radio>
      </Radio.Group>
    </Modal>
  );
};

export default TrierTransactionModal;
